import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import I18NextLivingMapBackend from "./I18NextLivingMapBackend";

i18n
  .use(I18NextLivingMapBackend) // Load translations through http (e.g., from a server)
  .use(LanguageDetector) // Detect language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    fallbackLng: "en-GB",
    lng: "en-GB",
    interpolation: { escapeValue: false }, // React already safe from XSS
    load: "currentOnly", // Load only the current language
  });

export default i18n;
